import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../services/token.service';

import { ROUTES } from '../constants'
import { EnvironmentService } from '../services/environment.service';

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  private env: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tokenService: TokenService,
    private envService: EnvironmentService
  ) {
  }

  async ngOnInit() {
    this.env = this.envService.getEnv();
    console.log(`[ngOnInit] env: ` , this.env)
    this.init();
  }

  init() {
    var code = this.route.snapshot.queryParamMap.get('code');
    console.log(`[init] code: ${code}`)
    if (code) {
      this.authorize(code);
    } else {
      this.loadCredentials()
    }
  }

  loadCredentials() {
    if (this.env.genesys.clientId) {
      console.log('loadCredentials - config: ' + JSON.stringify(this.env, null, 4))
      var url = `https://${this.env.genesys.authDomain}/oauth/authorize?client_id=${this.env.genesys.clientId}&response_type=code&redirect_uri=${this.env.genesys.redirectUri}`;
      console.log('URL: ' + url)
      window.location.href = url;
    } else {
      setTimeout(this.loadCredentials, 2000)
    }
  }

  authorize(code: string) {
    console.log('[authorize] Getting auth token. code:' + code)
    this.tokenService.getAuthToken(code)
      .subscribe(
        (res: any) => {
          console.log(`[authorize] res: `, res)
          if (res.access_token) {
            this.tokenService.setToken(res.access_token)
            this.router.navigate([`./${ROUTES.CONFIG}`]);
          }
        }, 
        error => console.error(error));
  }

}
